import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/user-groups`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  create({commit}, payload: { userIds: number[], userGroupCreation: object, companyId: number }) {
    return axiosInstance.post(`${baseUrl}`,
      {
        userIds: payload.userIds,
        userGroupCreation: payload.userGroupCreation,
        companyId: payload.companyId,
      }).then((data) => data.data);
  },
  update({commit}, payload: {groupId: number, addUsers: number[], removeUsers: number[], userGroup: object }) {
    return axiosInstance.put(`${baseUrl}/${payload.groupId}`,
      {
        addUsers: payload.addUsers,
        removeUsers: payload.removeUsers,
        userGroup: payload.userGroup,
      }).then((data) => data.data);
  },
  deleteById({commit}, payload: { id: number }) {
    return axiosInstance.delete(`${baseUrl}/${payload.id}`)
      .then((data) => data.data);
  },
  getById({commit}, payload: {id: number}) {
    return axiosInstance.get(`${baseUrl}/${payload.id}`)
     .then((data) => data.data);
  },
  getUsersInGroup({commit}, payload: {id: number, params: object}) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/users`, {params: payload.params})
        .then((data) => data.data);
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
